import React from "react";

const CustomChevronLeft: React.FC = () => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path d="M12.9075 23.815L1.49998 12.4075L12.9075 1" stroke="#545454" stroke-width="2" />
        </svg>
    );
};

export default React.memo(CustomChevronLeft);
